import React from "react";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import Style from "./ProductsInfo.module.scss";
const ProductsInfo = ({ data }) => {
  let totalPrice = null;
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {data.map((item) => {
        totalPrice += parseInt(item.price * item.count);
        return (
          <div key={item.product_id} className={Style.orderInfo}>
            <p className={Style.food}>{item.name}</p>
            <p className={Style.count}>{item.count} عدد</p>
            <p className={Style.price}>
              {separate(item.price * item.count)}
              <span style={{ fontSize: ".7rem" }}>تومان</span>
            </p>
            <p className={Style.productFee}>
              {separate(item.product_fee * item.count)}
              <span style={{ fontSize: ".7rem" }}>تومان کارمزد</span>
            </p>
          </div>
        );
      })}
      <div className={Style.total}>
        مجموع :<span style={{ color: "green" }}>{totalPrice} تومان </span>
      </div>
    </div>
  );
};

export default ProductsInfo;
